// Hook pobierajacy liste list zakupowych klienta z puli handlowca (tradera).
// GET /api/ui/sales-crm/clients/{clientId}/shopping-lists

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import {
  ICommandResponseError as IError,
  IPaginationRequest,
  IPaginationResponse
} from 'api/types';
import { IShoppingListListItem } from 'api/endpoints/useGetShoppingLists';

export type IRequest = IPaginationRequest & { search_keyword?: string };
type IResponse = IPaginationResponse<IShoppingListListItem>;

const getSalesCrmClientShoppingLists = (
  clientId: number,
  params?: IRequest
): Promise<IResponse> =>
  axios.get(`/sales-crm/clients/${clientId}/shopping-lists`, { params });

export const useGetSalesCrmClientShoppingLists = (
  clientId: number,
  params?: IRequest,
  options?: UseQueryOptions<IResponse, IError>
) =>
  useQuery<IResponse, IError>(
    ['sales-crm-client-shopping-lists', clientId, params],
    () => getSalesCrmClientShoppingLists(clientId, params),
    {
      ...options,
      enabled: options?.enabled !== false && clientId > 0
    }
  );
